export default __webpack_public_path__ + "static/media/tones.c0412c9d.png";